import React from 'react';

function SectionHeading({ eyebrow, children, centered = false }) {
  return (
    <header className={`section-heading${centered ? ' centered' : ''}`}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2>{children}</h2>
    </header>
  );
}

export default SectionHeading;